module.exports = [
  '$resource',

  function AppointmentResource(
    $resource,
  ) {
    const ResourceObject = $resource('/api/v2/appointments/:id',
      {
        id: '@id',
      },
      {
        get: {
          method: 'GET',
        },
        query: {
          url: '/api/v2/groups/:groupId/patients/:patientId/appointments',
          isArray: true,
          method: 'GET',
        },
        create: {
          method: 'POST',
          transformRequest: (data) => {
            const requestData = angular.merge({}, data);
            return angular.toJson(_.deepMapKeys(requestData, (value, key) => _.snakeCase(key)));
          },
        },
        patch: {
          method: 'PATCH',
        },
        confirm: {
          url: '/api/v2/appointments/:id/patient_statuses',
          method: 'POST',
        },
      },
    );

    angular.extend(ResourceObject.prototype, {
      $save(params, callback) {
        return this.$create(params, callback);
      },

      $cancel(successCallback, errorCallback) {
        return ResourceObject.patch(
          { id: this.id },
          { op: 'replace', path: '/cancelled', value: true, cancelled_on_behalf_of_patient: true },
          (response) => {
            this.cancelled = true;
            this.cancelledBy = this.availability.patient;
            this.cancelledAt = moment().toISOString();
            this.cancelledOnBehalfOfPatient = true;

            this.availability.appointment = null;
            this.availability.patient = null;

            if (successCallback) {
              successCallback(response);
            }
          },
          (response) => {
            if (errorCallback) {
              errorCallback(response);
            }
          },
        );
      },
    });

    return ResourceObject;
  },
];



// WEBPACK FOOTER //
// ./main/factories/appointment-resource.js